import React from 'react';
import emptyListIcon from './../images/emptyList.svg';
import './EmptyList.scss';

export const EmptyList = () => (
    <img className={'empty-list'} src={emptyListIcon} alt={'Flag'} />
);
